export enum ModalType {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  REGISTER_GUIDELINE = 'REGISTER_GUIDELINE',
  QR = 'QR',
  ERROR = 'ERROR',
  NETWORK_ERROR_RELOAD = 'NETWORK_ERROR_RELOAD',
  REPORT = 'REPORT',
  REPORT_OR_BLOCK = 'REPORT_OR_BLOCK',
  AFTER_MATCH_POPUP = 'AFTER_MATCH_POPUP',
  DM_REPORT = 'DM_REPORT',
  DM_LEAVE = 'DM_LEAVE',
  DM_BLOCK_AND_LEAVE = 'DM_BLOCK_AND_LEAVE',
  DM_SETTINGS = 'DM_SETTINGS',
  PROFILE_MODAL = 'PROFILE_MODAL',
  EDIT_PROFILE = 'EDIT_PROFILE',
  EDIT_PREFER_LANGUAGE = 'EDIT_PREFER_LANGUAGE',
  HEADER_POPUP = 'HEADER_POPUP',
  MATCH_SETTING = 'MATCH_SETTING',
  MATCH_SETTING_INNER = 'MATCH_SETTING_INNER',
  GEM_LACK = 'GEM_LACK',
  AGE_RANGE_MODAL = 'AGE_RANGE_MODAL',
  CMP_CONSENTS = 'CMP_CONSENTS',
  PLEDGE = 'PLEDGE',
  HISTORY = 'HISTORY',
  HISTORY_FILTER = 'HISTORY_FILTER',
  MORE = 'MORE',
  SHOP = 'SHOP',
  AGE_RESTRICTED = 'AGE_RESTRICTED',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  EFFECTS = 'EFFECTS',
  RETURN_EVENT_REMIND = 'RETURN_EVENT_REMIND',
  RETURN_EVENT_USING_ITEM = 'RETURN_EVENT_USING_ITEM',
  DSA_REPORT = 'DSA_REPORT',
  DSA_REPORT_CATEGORY_SELECT = 'DSA_REPORT_CATEGORY_SELECT',
  DSAR = 'DSAR',
  SAUDI_REWARD_GEM = 'SAUDI_REWARD_GEM',
  SAUDI_REWARD_REMIND = 'SAUDI_REWARD_REMIND',
  SAUDI_REWARD_INVITE_FRIEND_CODE = 'SAUDI_REWARD_INVITE_FRIEND_CODE',
  SAUDI_REWARD_USING_ITEM = 'SAUDI_REWARD_USING_ITEM',
  BLOG_CATEGORY = 'BLOG_CATEGORY',
  WEB_TO_APP = 'WEB_TO_APP',
  QUALITY_USER_BADGE = 'QUALITY_USER_BADGE',
  TOS_RE_APPROVAL = 'TOS_RE_APPROVAL',
  INVALID_AGE_CHECK = 'INVALID_AGE_CHECK',
  FEATURE_SETTINGS_CONSENTS = 'FEATURE_SETTINGS_CONSENTS',
  LOGIN_SUSPENSION = 'LOGIN_SUSPENSION',
  MATCH_SUSPENSION = 'MATCH_SUSPENSION',
  INDUCE_REGISTER_MODAL = 'INDUCE_REGISTER_MODAL',
  CANCEL_DELETION_RESERVATION = 'CANCEL_DELETION_RESERVATION',
  STARTER_PACKAGE_NUDGING = 'STARTER_PACKAGE_NUDGING',
  LEGAL_NOTICE_RE_APPROVAL = 'LEGAL_NOTICE_RE_APPROVAL',
  REPORT_AND_BLOCK_POPUP = 'REPORT_AND_BLOCK_POPUP',
  SUBSCRIPTION_POPUP = 'SUBSCRIPTION_POPUP',
  SUBSCRIPTION_PURCHASE_POPUP = 'SUBSCRIPTION_PURCHASE_POPUP',
  SUBSCRIPTION_PAYMENT = 'SUBSCRIPTION_PAYMENT',
  SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS',
  CONFIRM_LIQUIDITY_SHARING_OFF = 'CONFIRM_LIQUIDITY_SHARING_OFF',
  ITEM_INVENTORY = 'ITEM_INVENTORY',
  AZAR_FEEDBACK_DIALOG = 'AZAR_FEEDBACK_DIALOG',

  FACE_AGE_VERIFICATION = 'FACE_AGE_VERIFICATION',
  FACE_AGE_VERIFICATION_GUIDE = 'FACE_AGE_VERIFICATION_GUIDE',
  FACE_AGE_VERIFICATION_ERROR = 'FACE_AGE_VERIFICATION_ERROR',

  // 크리에이터 전용
  CREATOR_APPLY = 'CREATOR_APPLY',
  CREATOR_APPLY_REJECTED = 'CREATOR_APPLY_REJECTED',
  CREATOR_ONBOARDING = 'CREATOR_ONBOARDING',
  CREATOR_STUDIO = 'CREATOR_STUDIO',

  EDIT_NICKNAME = 'EDIT_NICKNAME',
  NOTICE_POPUP = 'NOTICE_POPUP',

  ETHNICITY_GUIDE = 'ETHNICITY_GUIDE',
  ITEM_LACK = 'ITEM_LACK',
  MATCH_TIMEOUT = 'MATCH_TIMEOUT',

  LIVENESS_SWITCH_ACCOUNT = 'LIVENESS_SWITCH_ACCOUNT',
  LANDSCAPE = 'LANDSCAPE',

  CAMERA_PUNISHMENT = 'CAMERA_PUNISHMENT',

  PROFILE_INPUT_INTRO = 'PROFILE_INPUT_INTRO',
  INTERESTS_SELECTION = 'INTERESTS_SELECTION',

  PWA_GUIDE = 'PWA_GUIDE',

  NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
  PRIVILEGED_ACTION_POPUP = 'PRIVILEGED_ACTION_POPUP',

  PUSH_NOTIFICATION_PERMISSION = 'PUSH_NOTIFICATION_PERMISSION',
  SUBSCRIPTION_GUIDE = 'SUBSCRIPTION_GUIDE',
  SUBSCRIPTION_BENEFIT_DETAIL = 'SUBSCRIPTION_BENEFIT_DETAIL',

  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION',
  SUBSCRIPTION_DUPLICATE = 'SUBSCRIPTION_DUPLICATE',

  ASSISTANT_CONSENT = 'ASSISTANT_CONSENT',
  ASSISTANT_CONSENT_LEAVE = 'ASSISTANT_CONSENT_LEAVE',
  SPEECH_RECOGNITION_PERMISSION = 'SPEECH_RECOGNITION_PERMISSION',
  STT_CONSENT_LEAVE = 'STT_CONSENT_LEAVE',
  SPEECH_RECOGNITION_DENIED_GUIDE = 'SPEECH_RECOGNITION_DENIED_GUIDE',

  CONFIRM_ASSISTANT_DISABLE = 'CONFIRM_ASSISTANT_DISABLE',
  ASSISTANT_WITHDRAW = 'ASSISTANT_WITHDRAW',

  DELETE_CONVERSATION_DATA = 'DELETE_CONVERSATION_DATA',
  CONFIRM_DELETE_CONVERSATION_DATA = 'CONFIRM_DELETE_CONVERSATION_DATA',

  HISTORY_DELETE_CARD_CONFIRM = 'HISTORY_DELETE_CARD_CONFIRM',
  HISTORY_REPORT_CONFIRM = 'HISTORY_REPORT_CONFIRM',

  INVITE_FROM_SWIPE_AZAR = 'INVITE_FROM_SWIPE_AZAR',
}

export enum ModalNavButtonType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  BACK_AND_CLOSE = 'BACK_AND_CLOSE',
  EXTERNAL_CLOSE = 'EXTERNAL_CLOSE',
  NONE = 'NONE',
}
